































import {
  computed,
  defineComponent,
  PropType,
  Ref,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons'
import { faSquare } from '@fortawesome/free-regular-svg-icons'
import { Option } from '~/models/shared/types'
import { mapBackendOptionToOption } from '~/utils/form'
import CToggleableContent from '~/components/shared/configurable/form/CToggleableContent.vue'

export default defineComponent({
  components: { CToggleableContent },
  props: {
    name: {
      type: String,
      required: true
    },
    paymentOptions: {
      type: Array as PropType<Option[]>,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      default: false
    },
    payment: {
      type: String,
      default: 'free'
    },
    price: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { value, paymentOptions, enabled, payment, price } = toRefs(props)
    const internalPayment = ref<string>(payment.value)
    const internalEnabled = ref<boolean>(enabled.value)
    const internalPrice = ref<string>(price.value)

    const icons = {
      checked: faCheckSquare,
      unchecked: faSquare
    }

    watch(payment, val => (internalPayment.value = val))
    watch(enabled, val => (internalEnabled.value = val))
    watch(price, val => (internalPrice.value = val))

    const paymentOptionSelectDisabled = computed(() => !enabled.value)
    const selectedPaymentOptionIsFree = computed(
      () => internalPayment.value === 'free'
    )
    const priceInputDisabled = computed(
      () => !enabled.value || selectedPaymentOptionIsFree.value
    )
    const priceInputPlaceholder = computed(() => {
      return ''
    })
    const formattedPaymentOptions: Ref<Option[]> = computed(() =>
      paymentOptions.value.map(mapBackendOptionToOption)
    )

    function handleEnabledChange(isEnabled: boolean) {
      internalEnabled.value = isEnabled
      emit('change', {
        value: value.value,
        enabled: isEnabled,
        payment: internalPayment.value,
        price: internalPrice.value
      })
    }

    function handlePaymentOptionSelectChange(paymentOption: string) {
      emit('change', {
        value: value.value,
        enabled: internalEnabled.value,
        payment: paymentOption,
        price: internalPrice.value
      })
    }

    function onPriceInput(price: string) {
      emit('change', {
        value: value.value,
        enabled: enabled.value,
        payment: internalPayment.value,
        price
      })
    }

    return {
      internalEnabled,
      icons,
      internalPayment,
      internalPrice,
      paymentOptionSelectDisabled,
      priceInputDisabled,
      priceInputPlaceholder,
      formattedPaymentOptions,
      handleEnabledChange,
      handlePaymentOptionSelectChange,
      onPriceInput
    }
  }
})
